import { useState } from "react";

export interface useModalReturnI<T> {
  target: T | null;
  setTarget: React.Dispatch<React.SetStateAction<T | null>>;
  open: boolean;
  handleClose: () => void;
}

export const useModal = <T = any>(): useModalReturnI<T> => {
  const [target, setTarget] = useState<T | null>(null);

  return {
    target,
    setTarget,
    open: !!target,
    handleClose: () => setTarget(null),
  };
};
